import React from 'react';
import PropTypes from 'prop-types';
import {
  AnalyticsChartLegend,
  AnalyticsLegendItem,
  AnalyticsLegendSwatch
} from 'routes/App/dashboard/styles';

const SalesPerHourLegend = ({series}) => (
  <AnalyticsChartLegend>
    {series.map((entry) => (
      <AnalyticsLegendItem key={entry.key} $color={entry.color}>
        <AnalyticsLegendSwatch $color={entry.color} />
        {entry.label}
      </AnalyticsLegendItem>
    ))}
  </AnalyticsChartLegend>
);

SalesPerHourLegend.propTypes = {
  series: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      color: PropTypes.string
    })
  )
};

SalesPerHourLegend.defaultProps = {
  series: []
};

export default SalesPerHourLegend;
